export default {
    dealers_tab_id: 'Id',
    dealers_tab_name: 'Name',
    dealers_tab_email: 'Email',
    dealers_tab_username: 'Username',
    dealers_tab_companies: 'Companies',
    dealers_tab_dealers: 'Dealers',
    dealers_tab_master_company_name: 'Master Company',
    dealers_tab_apply: 'Apply',
    dealers_tab_tags: 'Tags',
    dealers_tab_active_dealers_only: 'Active Accounts Only',
    dealers_tab_yes: 'Yes',
    dealers_tab_no: 'No',
    dealers_tab_authenticate_cloud: 'Login as Customer',
    dealers_tab_re_sync_backend_information: 'Re-sync Backend Information',
    dealers_tab_devices: 'Devices',
    dealers_tab_package: 'Package',
    dealers_tab_crm: 'Salesforce Id',
    dealers_tab_add_dealer: 'Add Dealer',
    dealers_tab_edit: 'Edit',
    dealers_tab_remove_filters: 'Remove filters',
    dealers_tab_account_details: 'Account Details',
    dealers_tab_import_from_p4: 'Import From P4',
    dealers_tab_reprocess_odo_hours: 'Reprocess Odo/Hrs',
    dealers_tab_new_status: 'New Status',
    dealers_tab_at: 'at',
    dealers_tab_next_scheduled_action: 'Next scheduled action on',
    dealers_tab_on: 'on',
    dealers_tab_brand: 'Brand',
};



